import type { ChannelSummary, CommsMember } from '../../interfaces/ICommsApi.js';
import { memberName } from './memberName.js';

/**
 * Display label for a conversation. Named channels (incl. General) carry their
 * own name; DMs have none, so the label is the *other* participant's name
 * resolved against the members directory. Falls back to the raw peer id when
 * the directory hasn't loaded yet.
 */
export function channelLabel(
  channel: ChannelSummary,
  currentUserId: string,
  members: CommsMember[],
): string {
  if (channel.kind !== 'dm') return channel.name ?? '';
  const peerId = channel.memberIds.find((id) => id !== currentUserId) ?? channel.memberIds[0];
  if (!peerId) return '';
  const peer = members.find((m) => m.id === peerId);
  return peer ? memberName(peer) : peerId;
}
